import { lazy } from 'react'

export const Login = lazy(() => import('./v1/Login'))
